import {Component, Input} from '@angular/core';
import {BrRundschauWetterbericht} from '../../../../../../../model/vorhersagen/br-wetterbericht';

@Component({
  selector: 'app-br-rundschauwetter-bericht',
  templateUrl: './br-rundschauwetter-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class BrRundschauwetterBerichtComponent {
  @Input() rundschauWetterbericht: BrRundschauWetterbericht;
}
